import React, { useState } from "react";
import { Grid, Typography, Box, Stack, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import { useNavigate } from "react-router-dom";
import AiLogoBlack from "../../assets/images/logo/AilogoBlack.svg";
import Link from "@mui/material/Link";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
const Footer = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <>
      <Grid container>
        <Box className={classes.contentAlign}>
          {/* <Grid xs={12}>
           
          </Grid> */}

          <Grid container sx={{ marginTop: "3rem" }} spacing={4}>
            <Grid xs={12} sm={6} md={3} className={classes.resposiveMargin}>
              <Link
                className={classes.smBlock}
                href="https://www.aiwritemate.com"
              >
                <img
                  src={AiLogoBlack}
                  width="60px"
                  class="img-fluid"
                  alt="ailogo"
                  className={classes.imgSm}
                />

                <div className={classes.imageContent}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontSize: "22px",
                      fontWeight: 600,
                      color: "#fff",
                      lineHeight: 1,
                      marginTop: "0px !important",
                    }}
                    gutterBottom
                  >
                    AI WRITE MATE
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{
                      fontSize: "18px",
                      fontWeight: 400,
                      color: "#fff",
                      lineHeight: 1,
                      marginTop: "0px !important",
                    }}
                    gutterBottom
                  >
                    Your AI Assistant
                  </Typography>
                </div>
              </Link>
            </Grid>
            <Grid xs={12} sm={6} md={3} className={classes.resposiveMargin}>
              <Typography variant="h2" className={classes.title} gutterBottom>
                Support
              </Typography>
              <Link
                variant="body2"
                sx={{ color: "#fff" }}
                href="mailto:support@aiwritemate.com"
              >
                support@aiwritemate.com
              </Link>
              {/* <Typography
                variant="subtitle1"
                className={classes.content}
                gutterBottom
                sx={{ textDecoration: "underline", cursor: "pointer" }}
              >
                support@aiwritemate.com
              </Typography> */}
            </Grid>

            <Grid xs={12} sm={6} md={3} className={classes.resposiveMargin}>
              <Typography variant="h2" className={classes.title} gutterBottom>
                Quick Links
              </Typography>
              <Link
                href={`https://www.aiwritemate.com/terms-&-condition`}
                variant="body2"
                target="_blank"
                rel="noopener"
                sx={{ color: "#fff" }}
              >
                Terms & Conditions
              </Link>
              <br />
              {/* <Typography
                variant="subtitle1"
                className={classes.content}
                gutterBottom
                onClick={() => navigate(`${config}/terms-&-condition.html`)}
                sx={{ textDecoration: "underline", cursor: "pointer" }}
              >
                Terms & Conditions
              </Typography> */}
              <Link
                href={`https://www.aiwritemate.com/privacy-policy`}
                target="_blank"
                rel="noopener"
                variant="body2"
                sx={{ color: "#fff" }}
              >
                {" "}
                Privacy & Policy
              </Link>
              {/* <Typography
                variant="subtitle1"
                className={classes.content}
                onClick={() => navigate(`${config}/privacy-policy.html`)}
                sx={{ textDecoration: "underline", cursor: "pointer" }}
                gutterBottom
              >
               
              </Typography> */}
            </Grid>
            <Grid xs={12} sm={6} md={3} className={classes.resposiveMargin}>
              <Typography variant="h2" className={classes.title} gutterBottom>
                Follow
              </Typography>
              <Stack
                direction="row"
                sx={{
                  margin: "-5px 0px 0px -10px !important",
                }}
                spacing={1}
              >
                <IconButton
                  component={Link}
                  target="_blank"
                  href="https://www.linkedin.com/in/ai-writemate-1760ba286/"
                  underline="none"
                >
                  <LinkedInIcon className={classes.iconStyle} />
                </IconButton>
                {/* <IconButton component={Link} target="_blank" href="https://www.linkedin.com/in/ai-writemate-189029269/ " underline="none">
                  <SubscriptionsOutlinedIcon className={classes.iconStyle} />
                </IconButton> */}
                <IconButton
                  component={Link}
                  target="_blank"
                  href="https://www.facebook.com/profile.php?id=100095164401858"
                  underline="none"
                >
                  <FacebookIcon className={classes.iconStyle} />
                </IconButton>
                <IconButton
                  component={Link}
                  target="_blank"
                  href="https://twitter.com/ai_writemate"
                  underline="none"
                >
                  <TwitterIcon className={classes.iconStyle} />
                </IconButton>
                <IconButton
                  component={Link}
                  target="_blank"
                  href="https://www.instagram.com/aiwritemate_ai/"
                  underline="none"
                >
                  <InstagramIcon className={classes.iconStyle} />
                </IconButton>
              </Stack>
            </Grid>
          </Grid>
        </Box>
        <Grid
          xs={12}
          textAlign="center"
          sx={{ background: "#090909", color: "#fff", padding: "1rem" }}
        >
          <Typography variant="subtitel2" gutterBottom>
            © 2023 by AI Write Mate. Powered and secured by{" "}
            <a href="https://www.enkefalos.com/" target="_blank">
              Enkefalos
            </a>{" "}
            | All Rights Reserved.
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  imageContent: {
    paddingLeft: "9px",
    marginTop: "10px",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "0px",
    },
  },

  contentAlign: {
    backgroundColor: "#0077b6",
    padding: "4rem",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      padding: "1.5rem 4rem",
    },
  },
  title: {
    fontWeight: 600,
    color: "#fff",
    lineHeight: 1,
    marginTop: "0px !important",
    marginBottom: "1rem",
  },
  iconStyle: {
    color: "whitesmoke",
    fontSize: "30px",
  },
  content: { color: "#fff", marginBottom: "0.5rem" },

  resposiveMargin: {
    [theme.breakpoints.down("md")]: {
      marginBottom: "2rem",
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: "1rem",
    },
  },
  imgSm: {
    [theme.breakpoints.down("sm")]: {
      marginLeft: "50px",
    },
  },
  smBlock: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
}));

export default Footer;